/* FoodNet v2.3 — business application validation */
(() => {
  'use strict';

  const cleanVat = (value) => String(value || '').toUpperCase().replace(/\s+/g, '').replace(/[^A-Z0-9.-]/g, '');

  const setInvalid = (input, message) => {
    if (!input) return;
    input.classList.add('business-v23__invalid');
    input.setAttribute('aria-invalid', 'true');
    input.setCustomValidity(message || 'Controleer dit veld.');
  };

  const clearInvalid = (input) => {
    if (!input) return;
    input.classList.remove('business-v23__invalid');
    input.removeAttribute('aria-invalid');
    input.setCustomValidity('');
  };

  function init(root) {
    const form = root.querySelector('#BusinessApplicationForm');
    if (!form || form.dataset.foodnetValidationReady === 'true') return;
    form.dataset.foodnetValidationReady = 'true';

    const vat = form.querySelector('[data-v23-vat]');
    const postcode = form.querySelector('[data-v23-postcode]');
    const country = form.querySelector('[data-v23-country]');
    const consent = form.querySelector('[data-v23-consent]');
    const status = form.querySelector('[data-business-form-status]');

    const clearStatusWhenValid = () => {
      if (!status) return;
      if (form.querySelector('.business-v23__invalid, :invalid')) return;
      status.textContent = '';
      status.hidden = true;
    };

    form.querySelectorAll('input,select,textarea').forEach((input) => {
      const clear = () => {
        clearInvalid(input);
        clearStatusWhenValid();
      };
      input.addEventListener('input', clear);
      input.addEventListener('change', clear);
    });

    vat?.addEventListener('blur', () => { vat.value = cleanVat(vat.value); });

    form.addEventListener('submit', (event) => {
      form.querySelectorAll('.business-v23__invalid').forEach(clearInvalid);
      let ok = form.checkValidity();

      if (vat) {
        vat.value = cleanVat(vat.value);
        const compact = vat.value.replace(/[.-]/g, '');
        if (compact.length < 8) {
          setInvalid(vat, 'Vul een geldig btw-nummer in.');
          ok = false;
        }
      }

      if (postcode && country?.value === 'België' && !/^\d{4}$/.test(postcode.value.trim())) {
        setInvalid(postcode, 'Belgische postcodes bestaan uit 4 cijfers.');
        ok = false;
      }

      if (consent && !consent.checked) {
        setInvalid(consent, 'Bevestig dat de bedrijfsgegevens correct zijn.');
        ok = false;
      }

      if (!ok) {
        event.preventDefault();
        if (status) {
          status.textContent = 'Controleer de gemarkeerde velden en probeer opnieuw.';
          status.hidden = false;
        }
        const first = form.querySelector('.business-v23__invalid, :invalid');
        first?.focus();
        form.reportValidity();
        return;
      }

      if (status) {
        status.textContent = '';
        status.hidden = true;
      }
    });
  }

  const boot = () => document.querySelectorAll('[data-business-application]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
